import './common'
import './forms'

import Vue from 'vue'
import Child from './Child.vue'
import Modal from './Modal.vue'
import PageHeader from './PageHeader.vue'

import Loader from './common/Loader.vue'
import PulsingRingLoader from './common/PulsingRingLoader.vue'

import NotFound from "./pages/NotFound.vue"

// Components that are registered globaly.
[
  Child,
  Modal,
  PageHeader,
  Loader,
  PulsingRingLoader,
  NotFound
].forEach(Component => {
  Vue.component(Component.name, Component)
})
